import financeiroApi from "@/app/services/financeiro";
import clientesApi from "@/app/services/clientes";

export default {
    namespaced: true,
    state: {
      cliente_id: null,
      cliente: {},
      promissoria: {},
      promissorias: [],
      promissoriasEmAberto: [],
      pagamentos: [],
      gerar_haver: false
    },

    getters: {
      somaPagamentos(state) {
        return state.pagamentos.reduce((soma, pagamento) => soma + pagamento.valor, 0);
      },
      somaPromissorias(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + parseFloat(promissoria.valor), 0);
      },
      somaRestante(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + promissoria.valor_restante, 0);
      },
      somaPagamentosPromissorias(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + promissoria.pagamento, 0);
      },
      somaSaldo(state) {
        return state.promissorias.reduce((soma, promissoria) => soma + promissoria.saldo, 0);
      },
      listaPromissoriasEmAberto(state) {
        return state.promissoriasEmAberto.filter(promissoria => {
          let indice = state.promissorias.findIndex(p => {
            return p.documento == promissoria.documento;
          })

          return indice == -1
        })
      }
    },

    mutations: {
      adicionarPromissoria(state, promissoria) {
        promissoria.pagamento = 0.0;
        promissoria.saldo     = promissoria.valor_restante;
        state.promissorias.push(promissoria);
      },

      adicionarRecebimento(state, pagamento) {
        state.pagamentos.push(pagamento);
      },

      removerRecebimento(state, pagamento) {
        let indice = state.pagamentos.indexOf(pagamento);

        if (indice > -1)
          state.pagamentos.splice(indice, 1);
      },

      limparPagamentosPromissorias(state) {
        state.promissorias = [];
        state.pagamentos = [];
        // state.cliente = {};
      },

      setCliente(state, cliente) {
        state.cliente = cliente;
      },

      setPromissoriasEmAberto(state, promissorias) {
        state.promissoriasEmAberto = promissorias;
      },

      removerPromissoria(state, promissoria) {
        let indice = state.promissorias.findIndex(promissoria_ => {
          return promissoria_.id == promissoria.id;
        });

        if (indice > -1)
          state.promissorias.splice(indice, 1);
      },

      atualizarPagamentosPromissorias(state){
        let totalPagamentos = state.pagamentos.reduce((soma, pagamento) => soma + pagamento.valor, 0);
        let resto           = totalPagamentos;

        state.promissorias.forEach((promissoria) => {
            
            let valorapagar = promissoria.valor_restante;

            if (resto > valorapagar) {

                promissoria.pagamento = valorapagar;
                promissoria.saldo     = 0;
                resto                 = resto - valorapagar;

            } else {

                if (resto > 0) {
                    promissoria.pagamento = resto;
                    promissoria.saldo     = valorapagar - promissoria.pagamento;
                    resto                 = resto - valorapagar
                } else {
                    promissoria.pagamento = 0;
                    promissoria.saldo     = valorapagar;
                    resto                 = 0;
                }

            }
        })
      },

      setGerarHaver(state, gerar_haver) {
        state.gerar_haver = gerar_haver;
      },

      SET_PROMISSORIA(state, promissoria) {
        state.promissoria = promissoria;
      }

    },

    actions: {
      async listarPromissoriasEmAberto({commit}, cliente_id) {
        // commit('LOADING_ON', null, {root: true});
        let promissorias = await financeiroApi.promissorias({cliente_id: cliente_id, tipo: 'abertas'});
        commit('setPromissoriasEmAberto', promissorias);
        // commit('LOADING_OFF', null, {root: true});
      },

      async finalizarRecebimento({commit, state}, cliente_id) {
        try {

          commit('LOADING_ON', null, {root: true});
          
          let post = {
            cliente_id: cliente_id,
            pagamentos: state.pagamentos,
            promissorias: state.promissorias,
            gerar_haver: state.gerar_haver
          }
          
          let promissorias = await financeiroApi.finalizarRecebimento(post);
        } finally {
          commit('LOADING_OFF', null, {root: true});
        }
      },

      async setCliente({commit}, cliente_id) {
        let cliente = await clientesApi.abrir(cliente_id);
        commit('setCliente', cliente);
      }
    }

}
